let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8GDyZ")).then(() => parcelRequire('l5SUo'));